import {ContainerBuilder} from './containerBuilder';

import type {Config} from '@config';

export function initContainer(config: Config) {
    return new ContainerBuilder(config).buildContainer();
}
